import { styled, isPropValid, isPropNotEqualTo, Colors } from '@unfold/theme';
import { IInputProps } from './types';
import { InputTheme } from './theme';
import { isString } from '@unfold/utils';

const getWidth = (width: string | number | undefined = 'auto'): string => {
  return isString(width) ? width : `${width}px`;
};

const getHeight = (height: string | number | undefined = '36px'): string => {
  return isString(height) ? height : `${height}px`;
};

export const InputContainer = styled('div', {
  shouldForwardProp: (prop) =>
    isPropValid(prop) &&
    isPropNotEqualTo(prop, ['width', 'height', 'placeholder']),
})<IInputProps>`
  display: flex;
  align-items: center;
  background-color: ${({ theme, appearance = 'default' }): string =>
    InputTheme[appearance][theme.name].backgroundColor};
  border-radius: ${({ theme, appearance = 'default' }): string =>
    InputTheme[appearance][theme.name].borderRadius};
  border: ${({ theme, appearance = 'default' }): string =>
    InputTheme[appearance][theme.name].border};
  width: ${({ width }): string => getWidth(width)};
  height: ${({ height }): string => getHeight(height)};
  padding: ${({ theme, appearance = 'default' }): string =>
    InputTheme[appearance][theme.name].padding};
  font-size: ${({ theme, appearance = 'default' }): string =>
    InputTheme[appearance][theme.name].fontSize};
  color: ${({ theme, appearance = 'default' }): string =>
    InputTheme[appearance][theme.name].color};
`;

export const InputControl = styled('input', {
  shouldForwardProp: (prop) =>
    isPropValid(prop) && isPropNotEqualTo(prop, ['width', 'height']),
})<IInputProps>`
  background: none;
  border: none;
  width: 100%;
  height: 100%;
  font-size: ${({ theme, appearance = 'default' }): string =>
    InputTheme[appearance][theme.name].fontSize};
  line-height: 24px;
  color: ${({ theme, appearance = 'default' }): string =>
    InputTheme[appearance][theme.name].color};
  outline: none;
  flex: 1;
  text-align: ${({ inputAlign = 'left' }): string => inputAlign};

  &::placeholder {
    color: ${(): string => Colors.G300};
    font-weight: 400;
    font-family: 'Clarkson', sans-serif;
    font-size: ${({ theme, appearance = 'default' }): string =>
      InputTheme[appearance][theme.name].fontSize};
    line-height: 24px;
  }

  &:disabled {
    color: ${(): string => Colors.G300};
    -webkit-text-fill-color: ${(): string => Colors.G300};
    opacity: 1;
  }
`;

export const ComponentBefore = styled.div`
  height: auto;
  width: auto;
`;
export const ComponentAfter = styled.div`
  height: auto;
  width: auto;
`;
